import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { LmsAssessmentTeacherAPIServiceV7 } from '@protos/learning_management/lms.assessment.teacher.apis_connect';
import {
  ResponseStatusCodeFunction,
  lmsTransportWithLogoutHandler,
} from './transports';

export const useLmsAssessmentTeacherAPIServiceV7WithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsAssessmentTeacherAPIServiceV7,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
